/**
 * Coordonnées de la fédération, émetteur par défaut de toute facture.
 *
 * Les valeurs proviennent des sources déjà en place dans l'application :
 * - dénomination, adresse, téléphone, e-mail : gabarit de facture du back-end
 *   (resources/views/CourriersEtExports/factureOrder2020.blade.php) ;
 * - numéro d'entreprise et IBAN : écran « Informations générales »
 *   (src/components/Outils/InfosGenerales.vue).
 */

import {aplatirSurBlanc} from './logo'

export const EMETTEUR_FEDERATION = {
  nom: 'Association Belge Francophone de Taekwondo - A.B.F.T.',
  adresse: '2057 Chaussée de Wavre',
  cp: '1160',
  ville: 'Auderghem',
  pays: 'Belgique',
  email: 'secretariat@abft.be',
  telephone: '02/347.34.77',
  numEntreprise: 'BE0419597155'
}

export const IBAN_FEDERATION = 'BE16 3400 0897 6174'

let promesseLogo = null

/**
 * Charge le logo de la fédération et le convertit en dataURL, seul format que
 * pdfmake sait intégrer.
 *
 * Le dataURL n'est jamais rangé dans le modèle : il pèse une centaine de
 * kilo-octets et saturerait le localStorage au bout de quelques factures. Il est
 * résolu à l'affichage, comme le QR.
 *
 * Résout toujours — `null` en cas d'échec — pour qu'un logo manquant n'empêche
 * jamais d'éditer ni d'exporter une facture.
 */
export function chargerLogoFederation () {
  if (promesseLogo) return promesseLogo

  promesseLogo = new Promise(function (resoudre) {
    let url
    try {
      // Variante à lettrage noir, lisible sur la feuille blanche : dans
      // logo_abft_new.png, « ABFT » est écrit en blanc, pour fonds sombres.
      // require et non import : le test unitaire ne doit pas avoir à résoudre
      // un PNG, que Jest ne sait pas transformer
      url = require('../../assets/img/logo_abft_impression.png')
    } catch (erreur) {
      resoudre(null)
      return
    }
    if (url && typeof url === 'object') url = url.default
    if (!url) {
      resoudre(null)
      return
    }
    // Selon le poids du fichier, url-loader renvoie soit un dataURL, soit une URL
    if (String(url).indexOf('data:') === 0) {
      aplatirSurBlanc(url).then(resoudre)
      return
    }

    const requete = new XMLHttpRequest()
    requete.open('GET', url, true)
    requete.responseType = 'blob'
    requete.onload = function () {
      if (requete.status < 200 || requete.status >= 300) {
        resoudre(null)
        return
      }
      const lecteur = new FileReader()
      lecteur.onload = function () { aplatirSurBlanc(lecteur.result).then(resoudre) }
      lecteur.onerror = function () { resoudre(null) }
      lecteur.readAsDataURL(requete.response)
    }
    requete.onerror = function () { resoudre(null) }
    requete.send()
  })

  return promesseLogo
}

export default {EMETTEUR_FEDERATION, IBAN_FEDERATION, chargerLogoFederation}



// WEBPACK FOOTER //
// ./src/utils/facture/federation.js